import type { PlanDto } from '@/lib/api';

/** Catálogo estático quando a API não responde (espelha `be/.../plan-catalog.ts`). */
export const LANDING_PLANS_FALLBACK: PlanDto[] = [
  {
    id: 'landing-basico',
    name: 'Básico',
    description: 'Plano básico mensal',
    value: 79.9,
    qtrDiscount: 5,
    yearlyDiscount: 10,
    freeTrialDays: 14,
    features: ['2 Análises IA', '10 Favoritos', '1 Arrematação'],
    popular: false,
  },
  {
    id: 'landing-pro',
    name: 'Pro',
    description: 'Plano profissional mensal',
    value: 129.9,
    qtrDiscount: 8,
    yearlyDiscount: 15,
    freeTrialDays: 14,
    features: ['10 Análises IA', '30 Favoritos', '5 Arrematações'],
    popular: true,
  },
  {
    id: 'landing-enterprise',
    name: 'Enterprise',
    description: 'Plano enterprise mensal',
    value: 199.9,
    qtrDiscount: 10,
    yearlyDiscount: 20,
    freeTrialDays: 14,
    features: [
      'Análises IA ilimitadas',
      'Favoritos ilimitados',
      'Arrematações ilimitadas',
      'PDF de análises',
      'Relatórios',
      'Suporte prioritário',
    ],
    popular: false,
  },
];
